<template>
  <div class="vehicleActivityInfo">
    <div class="addInfoTitle">{{ OfferDesc }}</div>
    <div class="addInfo">
      <div class="addList"  v-for="(item,index) in addList" :key="'add_'+index">
        <div class="mask" v-if="!(item.AutoCount>0)"></div>
        <img class="bg" src="@/assets/images/car/addListBg.png"/>
        <div class="addMain">
          <div class="addLeft" @click="confirm(item.ProductID, item.AutoCount)">
            <div class="title">{{item.ProductName}}</div>
            <div class="imgBox">
              <img :src="item.ClassImage"/>
            </div>
          </div>
          <div class="addRight">
            <div class="addBIcon" @click="confirm(item.ProductID, item.AutoCount)">{{item.Description}}</div>
            <div class="carInfo" @click="confirm(item.ProductID, item.AutoCount)">
              <div class="carName">
                <p>{{item.ClassCategory}}</p>
                <p>等同级别车型</p>
              </div>
              <div class="addPriceBox">
                <div class="addPrice">￥<p style="display: inline;">{{item.AvgPrice}}</p></div>
                <div class="addPriceSupplement">
                  <div>/日</div>
                  <div>{{ '专享价' }}</div>
                </div>
              </div>
            </div>
            <div class="carMainTips">
              <div class="zhimaPay">
                <!--芝麻信用·押金双免--><img src="@/assets/images/car/yajinshuangmian.png"/>
              </div>
              <div class="priceBtn" @click="showPriceList(item.ProductID)" :id="item.ProductID" data-rent="1">每日租金<div :class="{ 'active' : (item.ProductID)==currentCar }"></div></div>
            </div>
          </div>
        </div>
        <div class="price_details" :class="{'on': item.ProductID == currentCar }">
          <div class="weekTitle">
            <div class="week" v-for="(item, index) in weekList" :key="'week_'+index">{{item}}</div>
          </div>
          <div class="days">
            <div class="dayBox" :class="{'noDate': !option.date, 'on': option.ShowDate, 'onFirst': option.firstChild, 'onLast': option.lastChild }" v-for="(option, indexs) in item.Prices" :key="'day_'+indexs">
              <div class="zhanweibox"></div>
              <div class="day">
                <div class="date">{{ option.date || '' }}</div>
                <div class="price">{{ option.RealPrice ? '￥' + option.RealPrice : ''}}</div>
              </div>
              <div class="zhanweibox"></div>
            </div>
          </div>
          <div class="tips">
            <div class="txt deposit">
              车辆押金:
              <span>{{ item.Deposit }}</span>元
            </div>
            <div class="txt safe">
              基本保障服务费:
              <span>{{ item.InsuranceFee }}</span>元/天
            </div>
          </div>
        </div>
        <div class="addTips">
          <div class="carSurplus">{{ item.AutoCount>0 ? '仅剩'+item.AutoCount+'辆车' : '已满租' }}</div>
          <div class="carTipsList">
            <p><img src="@/assets/images/car/carTipsIcon.png"><span>车载充电器</span></p>
            <p><img src="@/assets/images/car/carTipsIcon.png"><span>手机支架</span></p>
            <p><img src="@/assets/images/car/carTipsIcon.png"><span>饮用水</span></p>
            <p><img src="@/assets/images/car/carTipsIcon.png"><span>纸巾</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="addFooter">
      <img src="@/assets/images/car/yanxuanBg.png"/>
    </div>
<!--    <div>{{'orgID:' + orgID}}&nbsp;&nbsp;{{'startTime:' + startTime}}&nbsp;&nbsp;{{'stopTime:' + stopTime}}</div>-->
  </div>
</template>

<script>
  import { getProductList } from "@/utils/api";
  import { getMonth, getDate, getDay } from "@/utils/formatDate";
  import { resourceUrl, orderSource, deviceType } from "@/utils/env";

  export default {
    name: "vehicleActivityInfo",
    data(){
      return {
        OfferDesc: '',
        orderSource: orderSource,
        resourceUrl: resourceUrl,
        deviceType: deviceType,
        currentCar: 0, //当前选中车辆
        weekList: ["日", "一", "二", "三", "四", "五", "六"],
        addList: [],
        orgID: 0,
        startTime: '0000-00-00 00:00:00',
        stopTime: '0000-00-00 00:00:00',
      }
    },
    created () {
    },
    mounted () {
      setTimeout(()=>{
        this.initData();
      },300);
    },
    methods: {
      async initData() {
        this.orgID = localStorage.getItem('orgID') || 0;
        this.startTime = localStorage.getItem('startTime') || '0000-00-00 00:00:00';
        this.stopTime = localStorage.getItem('stopTime') || '0000-00-00 00:00:00';
        let data = {
          offerid: this.$route.query.id,
          bizChannel: this.orderSource,
          orgid: this.orgID,
          start: this.startTime,
          end: this.stopTime
        };
        let res = await getProductList({
          data: data,
          isLoading: true,
          loadContent: "数据加载中..."
        });
        if (res.Code == 100) {
          this.$route.meta.title = res.Data.OfferName;
          this.OfferDesc = res.Data.OfferDesc;
          for( let j in (res.Data.ProductInfos || []) ){
            res.Data.ProductInfos[j].ClassImage = res.Data.ProductInfos[j].ClassImage ? resourceUrl + res.Data.ProductInfos[j].ClassImage.slice(2) : "";
            for (let i = 0; i < res.Data.ProductInfos[j].Prices.length; i++) {
              let date = res.Data.ProductInfos[j].Prices[i].PriceDate.replace("T", " ");
              res.Data.ProductInfos[j].Prices[i].date = getDate(date);
            }
            let date = res.Data.ProductInfos[j].Prices[0].PriceDate.replace("T", " ");
            let day = getDay(date) == 6 ? 0 : getDay(date);
            for (let i = day; i > 0; i--) {
              res.Data.ProductInfos[j].Prices.unshift({});
            }
            for (let i = 0; i < res.Data.ProductInfos[j].Prices.length; i++) {
              if( res.Data.ProductInfos[j].Prices[i].ShowDate == 1 ){
                res.Data.ProductInfos[j].Prices[i].firstChild = 1
                break;
              }
            }
            for (let i = 0; i < res.Data.ProductInfos[j].Prices.length; i++) {
              if( res.Data.ProductInfos[j].Prices[i].ShowDate == 1 && res.Data.ProductInfos[j].Prices[i+1].ShowDate == 0  ){
                res.Data.ProductInfos[j].Prices[i].lastChild = 1
                break;
              }
            }
          }
          this.addList = res.Data.ProductInfos;
        }
      },
      showPriceList(index) {
        if (index == this.currentCar) { index = 0; }
        this.currentCar = index;
      },
      confirm(id, num) {
        if( num>0 ){
          if( orderSource==16 ){ // 安卓
            let url = `/app/OrderConfirmActivity?class_id=${id}&shop_id=${this.orgID}&thirdCategory=Product_Auto_Rent_Tag`;
            dfpanda.openPage(JSON.stringify({type: 'app', url: url}));
          } else if( orderSource==17 ) { //IOS
            let url = `OrderConfirmActivity?class_id=${id}&shop_id=${this.orgID}&thirdCategory=Product_Auto_Rent_Tag`;
            window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: 'app', url: url}));
          }
        }
      },
    }
  }
</script>

<style lang="scss" scoped type="text/scss">
  /* 标题 */
  .addInfoTitle {
    width: 100%;
    text-align: center;
    font-size: 42px;
    line-height: 62px;
    font-weight: bold;
    color: #39342F;
    margin-top: 10px;
  }
  .addInfo {
    margin-top: 10px;
    .addList {
      width: 710px;
      min-height: 340px;
      margin: 30px 20px 0;
      box-shadow: 0 2px 18px rgba(0,0,0,0.16);
      border-radius: 10px;
      position: relative;
      background-color: #fff;
    }
    .mask {
      position: absolute;
      left: 0;
      top: -10px;
      width: 100%;
      height: 108%;
      z-index: 100;
      background: url('~@/assets/images/car/yichuzu.png') no-repeat right 10px;
      border-radius: 10px;
      background-size: 160px auto;
    }
    .addList .bg {
      position: absolute;
      top: -10px;
      left: 60px;
      z-index: 0;
      width: 125px;
      height: 176px;
    }
  }
  .addMain {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    padding: 30px 28px 0;
    position: relative;

  }
  .addLeft {

    .title {
      font-size: 26px;
      line-height: 44px;
      color: #fff;
      font-weight: bold;
      text-align: center;
    }
    .imgBox {
      width: 182px;
      height: 165px;
      position: relative;
      img {
        width: 182px;
        max-height: 165px;
        position: absolute;
        left: 0;
        bottom: 10px;
      }
    }
  }
  .addRight {
    margin-left: 28px;
    width: 440px;
    .addBIcon {
      width: 100%;
      font-size: 24px;
      line-height: 44px;
      border-bottom: 1px solid #d9d9d9;
      color: #090909;
      padding-bottom: 20px;
      background: url("~@/assets/images/car/icon-r.png") no-repeat right 10px;
      background-size: 13px 25px;
    }
  }
  .carInfo {
    width: 100%;
    display: flex;
    padding: 22px 0 0 0;
    justify-content: space-between;
  }
  .carName {
    width: 260px;
    p {
      display: block;
      color: #090909;
      font-size: 22px;
      /*line-height: 24px;*/
      width: 100%;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    p:first-child {
      font-weight: bold;
    }
  }
  .addPriceBox {
    width: auto;
    display: flex;
  }
  .addPrice {
    color: #FF6600;
    font-size: 22px;
    p {
      font-size: 44px;
      font-weight: bold;
      line-height: 50px;
    }
  }
  .addPriceSupplement {
    margin-left: 4px;
    padding-top: 4px;
    div:first-child {
      font-size: 16px;
      line-height: 20px;
    }
    div:last-child {
      font-size: 14px;
      color: #fff;
      width: 58px;
      line-height: 22px;
      text-align: center;
      background-color: #FF6600;
      border-radius: 29px;
    }
  }
  .carMainTips {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  .zhimaPay {
    width: 320px;
    img {
      width: 100px;
      vertical-align: middle;
    }
  }
  .priceBtn {
    font-size: 22px;
    color: #090909;
    padding-right: 24px;
    position: relative;
    line-height: 44px;
    > div {
      position: absolute;
      top: 10px;
      right: 0;
      width: 0;
      height: 0;
      border: 8px solid #090909;
      border-top: 8px solid #fff;
      border-right: 8px solid #fff;
      transform: rotate(-45deg);
    }
    div.active {
      top: 20px;
      transform: rotate(135deg);
    }
  }

  .price_details{
    width: 610px;
    margin: 0 auto;
    height: 0;
    overflow: hidden;
    transition: height 0.2s linear;
    .weekTitle{
      display: flex;
      font-size: 26px;
      .week{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 38px;
        flex: 1;
        color: #9F9F9F;
      }
      .week:first-child{
        color: #ff6804;
      }
      .week:last-child{
        color: #ff6804;
        border-right: none;
      }
    }
    .days{
      display: flex;
      flex-flow: wrap;
      .dayBox {
        display: flex;
        margin-top: 12px;
        box-sizing: border-box;
      }
      .dayBox.noDate {
        opacity: 0;
      }
      .zhanweibox {
        width: 5px;
        height: 100%;
        background-color: #FF8307;
        opacity: 0;
      }
      .day{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 70px;
        width: 76.5px;
        box-sizing: border-box;
        font-size: 22px;
        background-color: #F4F4F4;
        border-radius: 6px;
        overflow-y: hidden;
        .date{
          color: #B9B9B9;
        }
        .price{
          color: #090909;
        }
      }
    }
  }
  .price_details.on {
    height: 100%;
  }
  .price_details .days .dayBox.on .zhanweibox {
    opacity: 1;
  }
  .price_details .days .dayBox.on .day  {
    background-color: #FF8307;
    border-radius: 0;
  }
  .price_details .days .onFirst .day {
    border-top-left-radius: 6px !important;
    border-bottom-left-radius: 6px !important;
  }
  .price_details .days .onLast .day {
    border-top-right-radius: 6px !important;
    border-bottom-right-radius: 6px !important;
  }
  .price_details .days .onFirst .zhanweibox:first-of-type,
  .price_details .days .onLast .zhanweibox:last-of-type {
    opacity: 0 !important;
  }
  .price_details .days .dayBox.on .date, .price_details .days .dayBox.on .price{
    color: #fff;
  }
  .price_details .tips{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 17px 20px;
    line-height: 28px;
    font-size: 26px;
    border-bottom: 1px solid #d9d9d9; /* no */
  }
  .price_details .tips .txt{
    color: #B9B9B9;
    span {
      color: #ff7417;
    }
  }
  .price_details .tips .txt.safe{
    margin-left: 15px;
  }

  .addTips {
    padding: 26px 40px 20px 56px;
    display: flex;
  }
  .carSurplus {
    font-size: 20px;
    width: 134px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    color: #fff;
    background-color: #FFA800;
    border-radius: 17px;
  }
  .carTipsList {
    margin-left: 40px;
    font-size: 16px;
    color: #B9B9B9;
    line-height: 34px;
    display: flex;
    flex: auto;
    justify-content: space-between;
  }
  .carTipsList p {
    display: flex;
    align-items: center;
    >img {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      margin-right: 2px;
    }
  }

  /* 底部说明 */
  .addFooter {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    text-align: center;
    margin-top: 30px;
    > img {
      width: 100%;
    }
  }
</style>
